/**
 * ScrollCompensate - Adjusts window scroll position to keep content below
 * this element visually stable when the element's height changes.
 *
 * Measures height before and after LiveView DOM updates and compensates
 * by scrolling the window by the exact difference.
 */
const ScrollCompensateHook = {
  mounted() {
    this.prevHeight = this.el.offsetHeight;
  },

  beforeUpdate() {
    this.prevHeight = this.el.offsetHeight;
  },

  updated() {
    const newHeight = this.el.offsetHeight;
    const delta = newHeight - this.prevHeight;

    if (delta !== 0) {
      window.scrollBy({ top: delta, behavior: "instant" });
    }

    this.prevHeight = newHeight;
  },
};

export default ScrollCompensateHook;
